import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevrondown--menu",
  "use": "icon-chevrondown--menu-usage",
  "viewBox": "0 0 47.37 20.613",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 47.37 20.613\" id=\"icon-chevrondown--menu\">\n<g id=\"icon-chevrondown--menu_chevrondown--menu\">\n\t<polygon style=\"fill:#808080;\" points=\"23.686,20.613 0,5.01 3.301,0 23.686,13.428 44.069,0 47.37,5.01 \t\" fill=\"currentColor\" />\n</g>\n<g id=\"icon-chevrondown--menu_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol